import React from "react";
import { CurrentChatContext } from "@/components/context";
import { ChatCircleText } from "@phosphor-icons/react";
import { SidebarProps } from "@/lib/types";

export const NewChat = ({ sidebar }: SidebarProps) => {
    const { updateCurrentChat } = React.useContext(CurrentChatContext);
    const startNewChat = () => {
        updateCurrentChat(undefined);
        sidebar.setSidebarOpen(false);
    };
    return (
        <>
            <div className={"flex-none pt-4 pb-8 px-2"}>
                <div
                    className={
                        "flex flex-row items-center justify-center p-2 cursor-pointer hover:bg-zinc-700/10 rounded-xl text-lg lg:text-base"
                    }
                    onClick={startNewChat}
                >
                    <div className={"w-[24px] flex-none mr-2"}>
                        <ChatCircleText size={24} />
                    </div>
                    <div className={"flex-none lg:flex-1 font-bold"}>Start a new chat</div>
                </div>
            </div>
        </>
    );
};
